<template>
    <admin-layout 
    title="View Bookings - August 9, 2023"
    show-back
    :backUrl="`/home`">
        <BranchesLayout :branch-id="branchId" is-hidden>
            <template #contents>
                <!-- Filter -->
                <div class="px-6 py-3" v-if="isNetworkAvailable">
                    <FilterComponent
                        :search="searchText"
                        @fetchData="searchData"
                        @update:filters="applyFilters"
                    >
                    <template #fields>
                        <div class="space-y-6">
                            <DatePicker
                                id="filterCreatedDate"
                                name="filterCreatedDate"
                                range
                                is24
                                isPresetRanges
                                v-model="filterCreatedDate"
                                placeholder="Created Start and End Date"
                                label="Created Start and End Date"
                            />
                            <DatePicker
                                id="filterDate"
                                name="filterDate"
                                range
                                is24
                                isPresetRanges
                                v-model="filterDate"
                                placeholder="Booking Start and End Date"
                                label="Booking Start and End Date"
                            />
                            <MultiselectInput
                                v-model="bookingType"
                                label="Booking Type"
                                placeholder="Booking Type"
                                id="bookingTypes"
                                name="bookingTypes"
                                :options="bookingTypes"
                            />
                        </div>
                    </template>
                    </FilterComponent>
                </div>

                <div class="">
                    <DataTable 
                    :headers="headers" 
                    :count="items_count">
                        <template #body>
                            <tr v-for="(item, index) in items.data" :key="index">
                                <td class="px-6 py-3 text-sm text-gray-900 whitespace-nowrap">
                                    {{ item.patient_type != 'Soft' ? item.booking_id : item.id }}
                                </td>
                                <td class="px-6 py-3 text-sm text-gray-900 whitespace-nowrap">
                                    {{ item.patient?.first_name }} {{ item.patient?.last_name  }}
                                </td>
                                <td class="px-6 py-3 text-sm text-gray-900 whitespace-nowrap">
                                    {{ item.patient_type == 'Individual' || item.patient_type == 'Soft' || item.patient_type == 'Dependent' ? item.patient_type : 'Corporate' }}
                                </td>
                                <td class="px-6 py-3 text-sm text-gray-900 whitespace-nowrap">
                                    New
                                </td>
                                <td class="px-6 py-3 text-sm text-gray-900 whitespace-nowrap">
                                    Bonifacio Global City
                                </td>
                                <td class="px-6 py-3 text-sm text-gray-900 whitespace-nowrap">
                                    <template v-if="item.corporate_name">
                                        {{ item.corporate_name }}
                                    </template>
                                    <template v-else>
                                        -
                                    </template>
                                </td>
                                <td class="px-6 py-3 text-sm text-gray-900 whitespace-nowrap">
                                    Platinum Shinagawa Dock
                                </td>
                                <!-- <td class="px-6 py-3 text-sm text-gray-900 whitespace-nowrap">
                                    Chest X-ray
                                </td> -->
                                <td class="px-6 py-3 text-sm text-gray-900 whitespace-nowrap">
                                    10:00 am to 10:15 am
                                </td>
                                <td class="px-6 py-3 text-sm text-gray-900 whitespace-nowrap">
                                    P 26,500.00
                                </td>
                                <td class="px-6 py-3 text-sm text-gray-900 whitespace-nowrap">
                                    <StatusPill
                                    :color="getStatusColor(item.status)"
                                    :text="item.status"/>
                                </td>
                                <td class="px-6 py-3 text-sm text-gray-900 whitespace-nowrap">
                                    {{ new Date(item.booking_date).toISOString().split('T')[0] }}
                                </td>
                                <td class="px-6 py-3 text-sm text-gray-900 whitespace-nowrap">
                                    {{ new Date(item.booking_created_date ? item.booking_created_date : item.created_at).toISOString().split('T')[0] }}
                                </td>
                                <td class="text-center">
                                    <ActionButton
                                    v-if="
                                        $hasPermission('set-individual-patient-appointment-time') ||
                                        $hasPermission('update-individual-patient-appointment-time') ||
                                        $hasPermission('soft-book-dates-for-individual-patient') ||
                                        $hasPermission('update-corporate-patient') ||
                                        $hasPermission('update-participating-employees')"
                                    edit-btn
                                    @click="router.push(`/branches/${branchId}/bookings/edit/${item.patient_type == 'Individual' || item.patient_type == 'Dependent' ? item.booking_id : item.patient_type == 'Corporate' ? item.corporate_booking_id : item.id}?patient_type=${ item.patient_type == 'Individual' || item.patient_type == 'Soft' || item.patient_type == 'Dependent' ? item.patient_type : 'Corporate' }`)"/>
                                </td>
                            </tr>
                        </template>
                    </DataTable>    
                </div>

                <page-pagination class="mb-6" 
                    :items="items"  
                    @nextPage="indexBranchBooking"
                />
            </template>
        </BranchesLayout>

        <PageLoader v-if="loader" />

        <ErrorModal
            width="w-[548px]"
            title="Error"
            action-text="Close"
            cancel-text="Go back"
            :show="showError"
            @close="showError = false"
            @confirm="showError = false"
        >
            <template #content>
                {{ errorMsg }}
            </template>
        </ErrorModal>

        <SuccessModal
            :show="showSuccess"
            @cancel="showSuccess = false"
            @confirm="showSuccess = false"
            action-text="Close"
            title="Bookings Export"
            content="Export is being processed. Please check your registered email."
        />

        <LoadingModal
            :show="preCacheLoader && isNetworkAvailable"
            @cancel="preCacheLoader = false"
            @confirm="preCacheLoader = false"
            title="Downloading Resources"
            content="Resources is being download for offline use. Please wait."
        />

    </admin-layout>
</template>

<script setup lang="ts">
import AdminLayout from '@/layouts/AdminLayout.vue';
import BranchesLayout from '../branches/components/BranchesLayout.vue';
import FilterComponent from '@/components/FilterComponent.vue';
import DataTable from '@/components/DataTable.vue';
import ActionButton from '@/components/ActionButton.vue';
import StatusPill from '@/components/StatusPill.vue';
import PagePagination from '@/components/PagePagination.vue'
import DatePicker from '@/components/inputs/DatePicker.vue';
import MultiselectInput from '@/components/inputs/MultiselectInput.vue';

import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';
import LoadingModal from '@/components/modal/LoadingModal.vue';

import { useRouter, useRoute } from 'vue-router';
import { onMounted, ref, computed, watch } from 'vue';
import branchBooking from "@/classes/BranchBooking";
import BookingService from '@/classes/BookingService';
import { paginatePage } from '@/helpers/PageHelper';
import throttle from "lodash/throttle";
import { useNetworkStore } from '@/store/network';
import AuthService from "@/classes/AuthService";

const router = useRouter();
const route = useRoute();

// Data
const loader      = ref(false);
const showSuccess = ref(false);
const showError   = ref(false);
const errorMsg    = ref(null);
const branchId    = ref(route.params.id)
const status    = ref(route.query.status)

const networkStore = useNetworkStore();
const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);

// Query
const searchText = ref();
const filterDate = ref(null);
const filterCreatedDate = ref(null);
const bookingType = ref(null);
const goToPage   = ref();

const applyFilters = () => {
    indexBranchBooking(goToPage.value);
}

const searchData = (val: string) => {
    searchText.value = val
}

// Page Renderer Data
const items = ref([]);
const items_count = ref(0);


// Methods
const indexBranchBooking = (data: string) => {
    loader.value = true;

    // console.log(isNetworkAvailable.value)

    if(isNetworkAvailable.value) {
        console.log("Online - Fetching Bookings...")

        const goToPageValue    = paginatePage(data);
        const queryString      = searchText.value ? `&query=${searchText.value}` : 'query';
        const dateQuery        = filterDate.value ? `&filterDate=${filterDate.value}` : '';
        const dateCreatedQuery = filterCreatedDate.value ? `&filterCreatedDate=${filterCreatedDate.value}` : '';
        const branchId         = route.params.id ? `branchId=${route.params.id}` : '';
        const status           = route.query.status ? `status=${route.query.status}` : '';
        const type             = bookingType.value ? `bookingType=${bookingType.value}` : '';
        
        branchBooking.indexBranchBooking(`${branchId}&${goToPageValue}&${queryString}&${dateQuery}&${dateCreatedQuery}&${status}&${type}&requested_at=${new Date().toISOString()}`)
            .then((response: any) => {
                loader.value = false;
                items.value = response.data;
                items_count.value = response.data.total;

            })
            .catch((err) => {
                loader.value = false;
                showError.value = true;
                errorMsg.value = err.response.data.message;
                
                if(err.response.status == 401) {
                    window.location.replace('/login');
                }
            })
    } else {
        console.log("Offline - Fetching Bookings...")

        const goToPageValue   = paginatePage(data);
        const currentDate = new Date();
        const date = new Date(currentDate);
        date.setDate(currentDate.getDate() + 30);

        const dateQuery = `filterDate=${currentDate.toISOString().split("T")[0]},${date.toISOString().split("T")[0]}`;
        const branchId  = route.params.id ? `branchId=${route.params.id}` : '';
        
        branchBooking.indexBranchBooking(`${branchId}&${dateQuery}&${goToPageValue}&offline=true`)
            .then((response: any) => {
                loader.value = false;
                items.value = response.data;
                items_count.value = response.data.total;

            })
            .catch(() => {
                loader.value = false;
                showError.value = true;
                errorMsg.value = "Oppps... No available data was saved for offline use.";
            })
    }
        
}

const preCacheSelectedBooking = async (booking: any) => {
    try {
        // Precache Selected Booking
        if(booking.patient_type == 'Individual' || booking.patient_type == 'Dependent') {
            await BookingService.fetchIndividualBooking(booking.booking_id)
        } else {
            await BookingService.fetchCorporateBooking(booking.corporate_booking_id)
        }
    } catch(error: any){
        console.log(error.response.status)
    }
}

const preCacheSelectedBookingScheduleLogs = async (booking: any) => {
    try {
        // Precache Selected Booking Schedule Logs
        if(booking.patient_type == 'Individual' || booking.patient_type == 'Dependent') {
            await BookingService.fetchScheduleLogs(booking.patient_type, booking.booking_id)
        } else {
            await BookingService.fetchScheduleLogs(booking.patient_type, booking.corporate_booking_id)
        }
    } catch(error: any){
        console.log(error.response.status)
    }
}

const preCacheLoader = ref(false);
const isLastBookingIndexCached = ref(false);
const isLastSelectedBookingCached = ref(false);

const preCacheBookings = async () => {
    const currentDate = new Date();
    const date = new Date(currentDate);
    date.setDate(currentDate.getDate() + 30);
    
    const dateQuery       = `filterDate=${currentDate.toISOString().split("T")[0]},${date.toISOString().split("T")[0]}`;
    const branchId        = `branchId=${route.params.id}`;
    
    const cache = await caches.open('shinagawa-admin');
    const cachedResponse = await cache.match(`${process.env.VUE_APP_API_URL}branch-bookings/index?${AuthService.getHybrainTokenQueryString()}&${branchId}&${dateQuery}&offline=true`);

    if(!cachedResponse) {
        preCacheLoader.value = true;
        try {
            // Precache Bookings
            const response = await branchBooking.indexBranchBooking(`${branchId}&${dateQuery}&offline=true`)
            const total = response.data.total;
            const pages = Math.ceil(total / 10);
    
            for (let index = 0; index < pages; index++) {
                const page = index + 1;
                const res = await branchBooking.indexBranchBooking(`${branchId}&${dateQuery}&page=${page}&offline=true`)
    
                if(typeof res.data.data == 'object') {
                    let booking = null;
                    for (let i = 0; i < Object.values(res.data.data).length; i++) { 
                        booking = Object.values(res.data.data)[i];
                        preCacheSelectedBooking(booking);
                        preCacheSelectedBookingScheduleLogs(booking);
                        if (i === Object.values(res.data.data).length - 1) {
                            isLastSelectedBookingCached.value = true;
                            console.log("Last iteration for selected booking");
                        }
                    }
                } else {
                    let booking = null;
                    for (let i = 0; i < res.data.data.length; i++) {
                        booking = res.data.data[i];
                        preCacheSelectedBooking(booking);
                        preCacheSelectedBookingScheduleLogs(booking);

                        if (i === res.data.data.length - 1) {
                            isLastSelectedBookingCached.value = true;
                            console.log("Last iteration for selected patient");
                        }
                    }
                }

                if (index === pages - 1) {
                    isLastBookingIndexCached.value = true;
                    console.log("Last iteration for bookings index");
                }
            }

        } catch(error: any){
            console.log(error.response.status)
        }
        // preCacheLoader.value = false;
    }
}

// Headers
const headers: { text: string }[] = [
    { text: 'ID' },
    { text: 'Patient' },
    { text: 'Patient Type' },
    { text: 'Booking Type' },
    { text: 'Branch' },
    { text: 'Company' },
    { text: 'Package' },
    // { text: 'Rider' },
    { text: 'Timeslot' },
    { text: 'Total Fee' },
    { text: 'Status' },
    { text: 'Booking Date' },
    { text: 'Created Date' },
];

const bookingTypes = [
    { id: '1', label: 'All', value: 'All' },
    { id: '2', label: 'New', value: 'New' },
    { id: '3', label: 'Rescheduled', value: 'Rescheduled' },
];

const getStatusColor = (status: string) => {
    if(status) {
        let color = null;
        switch (status) {
            case 'Booked':
                color = 'blue';
                break;
        
            case 'Cancelled/No-Show':
            case 'Cancelled':
                color = 'red';
                break;
        
            case 'Done':
                color = 'green';
                break;
            
            default:
                color = 'yellow'
                break;
        }

        return color;
    }

    return 'yellow';
}


watch(
    searchText,
    throttle(() => {
        indexBranchBooking(goToPage.value)
    }, 1000)
);

watch(
    () => isNetworkAvailable.value,
    (val) => {
        console.log('Watcher - Network: ' + val);
        indexBranchBooking(goToPage.value);
    }
);

onMounted( () => {
    loader.value = true;
    setTimeout(() => {
        console.log('Mounted Hook - Network: ' + isNetworkAvailable.value);
        indexBranchBooking(goToPage.value);
        // preCacheBookings(); // Uncomment this line to pre-cache bookings
    }, 1000);

    // const checker = setInterval(() => {
    //     if(isLastBookingIndexCached.value && isLastSelectedBookingCached.value) {
    //         console.log("All resources has ben cached")
    //         preCacheLoader.value = false;
    //         clearInterval(checker);
    //     } else {
    //         console.log("Caching... plase wait")
    //     }
    // }, 1000)
});

</script>